import { TimePanelSource } from 'owa-time-panel-bootstrap';
import { trace } from 'owa-trace';

export function verifyValidSource(source: TimePanelSource): boolean {
    if (source) {
        return true;
    }
    trace.error('Source is a required parameter for Time Panel public APIs');
    return false;
}
